import { ref as n, watch as m, onUnmounted as k } from "vue";
import { focusTrap as E, focusElement as v } from "./td-longtail-vue-components92.js";
function D(t = n(null), r = void 0) {
  const o = n(!1), u = n(() => {
  }), i = n(() => {
  }), w = n((e) => {
  }), a = n(() => {
  }), c = n((e) => {
  }), s = () => {
    o.value = !1;
  }, d = () => {
    o.value = !0;
  }, l = (e) => {
    e.key === "Escape" && (s(), a.value()), t.value && E(t, e), r?.focusOnArrowKeys && v(t, e), c.value(e);
  };
  m(o, (e, y) => {
    e !== y && (e ? (u.value(), window.addEventListener("keydown", l)) : (i.value(), window.removeEventListener("keydown", l)));
  });
  const f = () => o.value ? (s(), !0) : !1, p = (e = void 0) => {
    o.value = !o.value, w.value(o.value), r?.focusFirstOnOpen && e && e.target && "pointerType" in e && e.pointerType === "" && setTimeout(() => {
      e.key = "ArrowDown", v(t, e);
    }, 1);
  };
  return k(() => {
    window.removeEventListener("keydown", l);
  }), {
    isOpened: o,
    onClickaway: f,
    keyDown: c,
    onEsc: a,
    onOpen: u,
    onClose: i,
    toggle: p,
    close: s,
    open: d
  };
}
export {
  D as default
};
